// Renders above the upload drop-zone when previous spots in the same
// session have uploaded a logo. Click → the active draft adopts that
// upload key + filename + mime-type, and the +$30 digitisation fee is
// skipped (the customer already paid for that file in spot N).

import type { PriorLogo } from "../pricing";

export function LogoReuseTile({
  prior,
  onPick,
}: {
  prior: PriorLogo;
  onPick: () => void;
}) {
  return (
    <button
      type="button"
      className="rk-pc-reuse-tile"
      onClick={onPick}
      title={`Reuse the design you uploaded on spot ${prior.fromSpotIndex}: no extra digitisation fee.`}
    >
      <span className="rk-pc-reuse-tile__check">↺</span>
      <span className="rk-pc-reuse-tile__body">
        <span className="rk-pc-reuse-tile__title">Reuse {prior.filename}</span>
        <span className="rk-pc-reuse-tile__sub">
          From spot {prior.fromSpotIndex} · no extra $30
        </span>
      </span>
    </button>
  );
}
